import { useMutation } from '@tanstack/react-query';
import { logoutRequest } from '@/api/auth';

export function useLogout() {
  return useMutation<void, unknown, void>({
    mutationFn: logoutRequest,
  });
}
